import { render, staticRenderFns } from "./TeamMemberAuditExportTable.vue?vue&type=template&id=c5cb2b46&"
import script from "./TeamMemberAuditExportTable.vue?vue&type=script&lang=js&"
export * from "./TeamMemberAuditExportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports